document.addEventListener("DOMContentLoaded", function () {
  console.log("Subconscious Selling Popup Initialized");

  function createPopupContainer() {
    if (document.getElementById("subconscious-selling-popup")) {
      return;
    }

    const popupContainer = document.createElement("div");
    popupContainer.id = "subconscious-selling-popup";
    popupContainer.className = "subconscious-selling-popup";

    popupContainer.innerHTML = `
      <div class="subconscious-popup-content" role="dialog" aria-live="polite" aria-label="Limited time special offer">
        <div class="subconscious-popup-header">
          <h3>Exclusive Healing Opportunity</h3>
          <button class="subconscious-popup-minimize" aria-label="Minimize popup">❌</button>
        </div>
        <div class="subconscious-popup-body">
          <p class="subconscious-popup-message desktop-message">
            <span class="highlight-text">Only 33 spots remain</span> to experience a <em>personalized</em> Ho'oponopono session<br>plus <span class="highlight-text">lifetime access</span> to our calming Friday Healing Circles
          </p>
          <p class="subconscious-popup-message mobile-message">
            <span class="highlight-text">33 spots left</span> – personalized healing awaits
          </p>
          <div class="subconscious-popup-price" aria-label="Price offer">
            <span class="original-price" aria-hidden="true">$2,144</span>
            <span class="offer-price price-display" data-contains-price="true" aria-live="assertive" aria-atomic="true">$28</span>
          </div>
          <a href="/cart/51763076956478:1?checkout" class="subconscious-popup-button" aria-label="Join healing session now">Join the Healing Circle</a>
          <p class="trust-message" aria-hidden="true">Trusted by over <strong>500+</strong> healed souls worldwide</p>
        </div>
      </div>
    `;

    document.body.appendChild(popupContainer);

    const styleElement = document.createElement("style");
    styleElement.textContent = `
      .subconscious-selling-popup {
        position: fixed;
        bottom: 20px;
        right: 20px;
        background: linear-gradient(135deg, #7B5FC0, #FF6BA3);
        border-radius: 12px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
        z-index: 9999;
        width: 320px;
        color: white;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        overflow: hidden;
        transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.4s ease;
        opacity: 1;
      }
      
      .subconscious-selling-popup.minimized {
        transform: translateY(calc(100% - 40px));
        opacity: 0.6;
      }
      
      .subconscious-selling-popup.closing {
        transform: translateY(100%);
        opacity: 0;
      }
      
      .subconscious-popup-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 18px;
        background: rgba(0, 0, 0, 0.15);
        cursor: pointer;
        user-select: none;
      }
      
      .subconscious-popup-header h3 {
        margin: 0;
        font-size: 17px;
        font-weight: 600;
        letter-spacing: 0.03em;
      }
      
      .subconscious-popup-minimize {
        background: none;
        border: none;
        color: white;
        font-size: 20px;
        cursor: pointer;
        padding: 0 6px;
        line-height: 1;
        transition: color 0.3s ease;
      }
      
      .subconscious-popup-minimize:hover {
        color: #FFD700;
      }
      
      .subconscious-popup-body {
        padding: 16px 20px;
        text-align: center;
      }
      
      .subconscious-popup-message {
        font-size: 15px;
        line-height: 1.4;
        margin-bottom: 18px;
        font-weight: 500;
      }
      
      .mobile-message {
        display: none;
      }
      
      .highlight-text {
        font-weight: 700;
        color: #FFD700;
        text-shadow: 0 0 6px rgba(255, 215, 0, 0.8);
      }
      
      .subconscious-popup-price {
        margin-bottom: 18px;
        display: flex;
        justify-content: center;
        align-items: baseline;
        gap: 14px;
      }
      
      .original-price {
        font-size: 16px;
        text-decoration: line-through;
        opacity: 0.65;
        font-style: italic;
      }
      
      .subconscious-popup-price .offer-price {
        font-size: 26px;
        font-weight: 700;
        color: #FFD700;
        text-shadow: 0 0 8px rgba(255, 215, 0, 0.9);
        letter-spacing: 0.05em;
      }
      
      .subconscious-popup-button {
        display: inline-block;
        background-color: #FFD700;
        color: #2c2c2c;
        text-decoration: none;
        padding: 12px 24px;
        border-radius: 30px;
        font-weight: 700;
        box-shadow: 0 4px 10px rgba(255, 215, 0, 0.6);
        transition: background-color 0.3s ease, transform 0.2s ease, box-shadow 0.3s ease;
      }
      
      .subconscious-popup-button:hover {
        background-color: #FFC700;
        transform: translateY(-3px);
        box-shadow: 0 6px 14px rgba(255, 215, 0, 0.85);
      }

      .trust-message {
        font-size: 12px;
        font-style: italic;
        color: rgba(255, 255, 255, 0.75);
        margin-top: 10px;
      }
      
      @media (max-width: 767px) {
        .subconscious-selling-popup {
          width: calc(100% - 32px);
          bottom: 12px;
          right: 12px;
          left: 12px;
        }
        
        .desktop-message {
          display: none;
        }
        
        .mobile-message {
          display: block;
          font-size: 14px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-weight: 600;
        }
        
        .subconscious-popup-body {
          padding: 12px 16px;
        }
        
        .subconscious-popup-price {
          margin-bottom: 12px;
        }
        
        .subconscious-popup-button {
          padding: 10px 20px;
          margin-top: 8px;
        }
      }
    `;

    document.head.appendChild(styleElement);

    const headerElement = popupContainer.querySelector(
      ".subconscious-popup-header"
    );
    const minimizeButton = popupContainer.querySelector(
      ".subconscious-popup-minimize"
    );

    // Auto-close functionality
    let autoCloseTimeout;
    
    function closePopup() {
      popupContainer.classList.add("closing");
      setTimeout(() => {
        if (popupContainer.parentNode) {
          popupContainer.parentNode.removeChild(popupContainer);
        }
      }, 400); // Wait for animation to complete
    }

    // Set auto-close timer for 6 seconds
    autoCloseTimeout = setTimeout(closePopup, 6000);

    // Clear auto-close timer if user interacts with popup
    function clearAutoClose() {
      if (autoCloseTimeout) {
        clearTimeout(autoCloseTimeout);
        autoCloseTimeout = null;
      }
    }

    headerElement.addEventListener("click", function (e) {
      clearAutoClose(); // Stop auto-close when user interacts
      if (e.target !== minimizeButton) {
        popupContainer.classList.toggle("minimized");
      }
    });

    minimizeButton.addEventListener("click", function () {
      clearAutoClose(); // Stop auto-close when user minimizes
      popupContainer.classList.toggle("minimized");
    });

    // Clear auto-close if user hovers over the popup (optional)
    popupContainer.addEventListener("mouseenter", clearAutoClose);
    
    // Clear auto-close if user clicks the CTA button
    const ctaButton = popupContainer.querySelector(".subconscious-popup-button");
    ctaButton.addEventListener("click", clearAutoClose);
  }

  createPopupContainer();
});